import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_2 = { class: "mb-0 text-paragraph" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "mt-15 mt-md-0" }
const _hoisted_6 = { class: "pagination mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" Showing "),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.pagination.count), 1),
      _createTextVNode(" out of "),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pagination.total), 1),
      _createTextVNode(" results ")
    ]),
    _createElementVNode("nav", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: !_ctx.pagination.links.previous }])
        }, [
          _createElementVNode("a", {
            class: "page-link",
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToPage(_ctx.pagination.current_page-1)), ["prevent"])),
            "aria-label": "Previous"
          }, _hoisted_8)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationRange, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["page-item", { active: page === _ctx.pagination.current_page }]),
            key: page
          }, [
            _createElementVNode("a", {
              class: "page-link",
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
            }, _toDisplayString(page), 9, _hoisted_9)
          ], 2))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: !_ctx.pagination.links.next }])
        }, [
          _createElementVNode("a", {
            class: "page-link",
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.goToPage(_ctx.pagination.current_page+1)), ["prevent"])),
            "aria-label": "Next"
          }, _hoisted_11)
        ], 2)
      ])
    ])
  ]))
}